import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import { localizeApiFieldError } from '../../../../config/apiValidation';
import { connect } from "trim-redux";
import {Checkbox, Divider, FormControlLabel, InputAdornment, MenuItem} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../components/elements/LoadingButton";
import { Styles } from '../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import {isAdmin, isCourier, rolesWithName} from "../../../../config/Permissions";
import {useNavigate} from "react-router-dom";

import {useParams} from "react-router";
import {updateRedux} from "../../../../config/Security";
import {useTranslation} from "react-i18next";
import RayaField from "../../../components/elements/fields/RayaField";
import MobileField from "../../../components/elements/fields/MobileField";
import moment from "moment";
import GetConfirmationText from "../../../components/elements/GetConfirmationText";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import {BadgeCheck, Trash} from "lucide-react";
import Tooltip from "@mui/material/Tooltip";
import UserDetailsSkeleton from "../../../components/loaders/UserDetailsSkeleton";
import SubTitle from "../../../components/elements/SubTitle";

const MakeUser = (props) => {
    const { classes } = props;
    const navigation = useNavigate();

    const [fields, setFields] = useState({
        email: '',
        mobile: '',
        country: null,
        first_name: '',
        last_name: '',
        birthdate: "",
        iban: '',
        role: 'user',
        courier_leave: 0,
    });
    let { id } = useParams();
    if(!id){
        id = props.user.id;
    }
    const [errors, setErrors] = useState({});
    const [avatar, setAvatar] = useState(null);
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [disableEmail, setDisableEmail] = useState(false);
    const [disableMobile, setDisableMobile] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/users/get/${id}`,config)
            .then(response => {
                setFields({
                    email: response.data.email ?? '',
                    mobile: response.data.mobile ?? '',

                    first_name: response.data.first_name ?? '',
                    last_name: response.data.last_name ?? '',
                    iban: response.data.iban ?? '',
                    birthdate: !!response.data.birthdate ? moment(response.data.birthdate).format("YYYY-MM-DD") : "",
                    role: response.data.role.name,
                    mobile_confirmed: response.data.mobile_confirmed,
                    email_confirmed: response.data.email_confirmed,
                    courier_leave: response.data.courier_leave,
                });
                if(!!response.data.mobile) setDisableMobile(true);
                if(!!response.data.email) setDisableEmail(true);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        // Fetch match data when component mounts
        loadData();
    }, [id]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleChangeField = (field,val) => {
        setFields((prevFields) => ({ ...prevFields, [field]: val }));
        setErrors((prevErrors) => ({ ...prevErrors, [field]: '' }));
    };
    const setMobileField = (country, mobile) => {
        setFields((prevFields) => ({
            ...prevFields,
            country,
            mobile
        }));
        setErrors((prevErrors) => ({ ...prevErrors, mobile: '' }));
    };

    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.first_name)) {
            formIsValid = false;
            newErrors.first_name = t('emptyField');
        } else if (!validator.isByteLength(fields.first_name, { min: 0, max: 255 })) {
            formIsValid = false;
            newErrors.first_name = t('maxLength255');
        }
        // Validation for full_name
        if (validator.isEmpty(fields.last_name)) {
            formIsValid = false;
            newErrors.last_name = t('emptyField');
        } else if (!validator.isByteLength(fields.last_name, { min: 0, max: 255 })) {
            formIsValid = false;
            newErrors.last_name = t('maxLength255');
        }



        // Validation for mobile
        if (validator.isEmpty(fields.mobile)) {

        }else if(fields.mobile.length < 9 ){
            formIsValid = false;
            newErrors.mobile = t('wrongMobile');
        }
        // Validation for email
        if (validator.isEmpty(fields.email)) {

        } else if (!validator.isEmail(fields.email)) {
            formIsValid = false;
            newErrors.email = t('wrongEmail');
        }

        if(!!formIsValid){
            // API check for email and mobile
            const data = new FormData();
            data.append('email', fields.email);
            if(!disableMobile && fields.mobile && fields.country){
                let mobile = Number(fields.mobile).toString();
                mobile = fields.country?.phonecode+mobile;
                data.append("mobile", mobile);
            }
            data.append('user_id', id);

            const loginToken = localStorage.getItem('ACT');
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };

            try {
                const response = await axios.post(`${defaultVariables.url}/auth/check-info`, data, config);
                const apiErrors = response.data.errors;
                if (apiErrors.mobile) {
                    formIsValid = false;
                    newErrors.mobile = localizeApiFieldError("mobile", apiErrors.mobile[0], t);
                }
                if (apiErrors.email) {
                    formIsValid = false;
                    newErrors.email = localizeApiFieldError("email", apiErrors.email[0], t);
                }

            } catch (error) {
                console.error(error);
            }
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('first_name', fields.first_name);
        data.append('last_name', fields.last_name);
        if(!disableEmail){
            data.append('email', fields.email);
        }
        if(!disableMobile){
            let mobile = Number(fields.mobile).toString();
            if(mobile.length > 3){
                mobile = fields.country?.phonecode+mobile;
                data.append("mobile", mobile);
                data.append("code", fields.country?.phonecode);
            }
        }
        data.append('birthdate', fields.birthdate);
        data.append('iban', fields.iban);
        data.append('user_id', id);
        data.append('courier_leave', !!fields.courier_leave ? 1 : 0);

        if(!!isAdmin()){
            data.append('role', fields.role);
        }
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            await axios.post(`${defaultVariables.url}/users/edit`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            if(!!isAdmin()){
                navigation(`/panel/manage/${props.type === "courier" ? "couriers" : "users"}/view-all`);
            }else{
                updateRedux();
            }

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
        }
    };
    const handleRemoveUser = async () => {

        const data = new FormData();
        data.append('id', id);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            await axios.post(`${defaultVariables.url}/users/remove`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            navigation(`/panel/manage/${props.type === "courier" ? "couriers" : "users"}/view-all`);

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };

    if (loading) {
        return <UserDetailsSkeleton />;
    }

    return (
        <Grid container spacing={2}>
            <CssBaseline />
            {
                (isAdmin() && !props.details) &&
                <Grid item size={{xs:12}} className="manage-org-sec">
                    <GetConfirmationText
                        tooltip={t('removeUser')}
                        handleAction={handleRemoveUser}
                        icon={<DeleteRoundedIcon />}
                        startIcon={<Trash className="lucide-icon"/>}
                        buttonColor="default"
                        variant="outlined"
                    >
                        {t('removeUser')}
                    </GetConfirmationText>
                </Grid>
            }
            {
                ((props.type === "courier") || !!isCourier()) &&
                <Grid item size={{ xs: 12 }}>
                    <FormControlLabel
                        label={t('courierOnLeave')}
                        name="courier_leave"
                        control={<Checkbox checked={fields.courier_leave} onChange={() => handleChangeField('courier_leave',!fields.courier_leave)} />}
                    />
                </Grid>
            }
            <Grid item size={{xs:12}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    label={t('first_name')}
                    name="first_name"
                    value={fields.first_name}
                    onChange={handleChange}
                    error={!!errors.first_name}
                    helperText={errors.first_name}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    label={t('last_name')}
                    name="last_name"
                    value={fields.last_name}
                    onChange={handleChange}
                    error={!!errors.last_name}
                    helperText={errors.last_name}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <RayaField
                    fullWidth
                    optional
                    variant="outlined"
                    value={fields.birthdate}
                    label={t('birthdate')}
                    name="birthdate"
                    type="date"
                    onChange={handleChange}
                    error={!!errors['birthdate']}
                    helperText={errors['birthdate']}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    id="email"
                    label={t('email')}
                    name="email"
                    autoComplete="email"
                    value={fields.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                    disabled={disableEmail}
                    slotProps={!!fields.email_confirmed && {
                        input:{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title={t('emailIsConfirmed')}>
                                        <BadgeCheck className="lucide-icon-secondary"/>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }
                    }}
                />

            </Grid>
            <Grid item size={{xs:12}}>
                {
                    !!disableMobile ?
                        <>
                            <RayaField
                                variant="outlined"
                                required
                                fullWidth
                                label={t('mobile')}
                                name="mobile"
                                value={fields.mobile}
                                error={!!errors.mobile}
                                helperText={errors.mobile}
                                disabled
                                slotProps={!!fields.mobile_confirmed && {
                                    input:{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title={t('mobileIsConfirmed')}>
                                                    <BadgeCheck className="lucide-icon-secondary"/>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }
                                }}
                            />
                        </>

                        :
                        <MobileField
                            setMobile={setMobileField}
                            error={errors['mobile']}
                        />
                }
            </Grid>
            <Grid item size={12}>
                <SubTitle align="left">{t('bankInfo')}</SubTitle>
            </Grid>
            <Grid item size={{xs:12}}>
                <RayaField
                    variant="outlined"
                    fullWidth
                    label={t('iban')}
                    name="iban"
                    value={fields.iban}
                    onChange={handleChange}
                    type="number"
                    error={!!errors.iban}
                    helperText={!!errors.iban ? errors.iban : t('ibanHelper')}
                />
            </Grid>
            {
                isAdmin() &&
                <>
                    <Grid item size={12}>
                        <Divider/>
                    </Grid>
                    <Grid item size={{xs:12}}>
                        <RayaField
                            select
                            fullWidth
                            variant="outlined"
                            required
                            name="role"
                            id="role"
                            label={t('role')}
                            value={fields.role}
                            onChange={handleChange}
                        >
                            {rolesWithName().map((row, key) => (
                                <MenuItem value={row.value} key={key}>
                                    {row.name}
                                </MenuItem>
                            ))}
                        </RayaField>
                    </Grid>
                </>

            }
            <Grid
                item
                size={12}
                sx={props.details ? { display: "flex", justifyContent: "center" } : undefined}
            >
                <LoadingButton
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    loading={submitLoading}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>
        </Grid>

    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(MakeUser));
